// Lesson management routes
import Lessons from '../../components/Lessons.vue'
import LessonDetail from '../../components/LessonDetail.vue'
import LessonCreate from '../../components/LessonCreate.vue'

export default [
  {
    path: '/lessons',
    name: 'Lessons',
    component: Lessons,
    meta: { 
      requiresAuth: true,
      title: 'Lesson Management'
    }
  },
  {
    path: '/lessons/new',
    name: 'LessonCreate',
    component: LessonCreate,
    meta: { 
      requiresAuth: true,
      title: 'Create New Lesson'
    }
  },
  {
    path: '/lessons/:id',
    name: 'LessonDetail',
    component: LessonDetail,
    meta: { 
      requiresAuth: true,
      title: 'Lesson Details'
    }
  }
] 